import { CardContent, Button, Card, Grid, Divider, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Snackbar, Backdrop, CircularProgress } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import Alert from 'src/components/Alert';




const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Segoe UI",
    width: '100%',
    height: '100%'
  }, backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  },
  cardContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500',
  },
  button: {
    padding: theme.spacing(2),
    fontSize: '1rem',
  },
}));

function SarisFcmCalculate() {

  const classes = useStyles();
  const [fcmData, setFcmData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });



  useEffect(() => {
    HandleGetFcmCalculator();
  }, []);

  const HandleGetFcmCalculator = () => {
    setLoading(true);
    axios.get(`SetSarisFcmCalculate/`)
      .then((response) => {
        setLoading(false);
        var data = response.data;
        setFcmData(data);
        setLoading(false);
        return;
      }).catch((error) => {
        setLoading(false);
        return;
      });
  };

  const fcmCalculator = () => {
    setLoading(true);
    axios.get(`GetSarisFcmCreate/`)
      .then((response) => {
        setLoading(false);
        var data = response.data;
        if (data == 0) {
          setUyariTip('success');
          setresponseMessage("Bu akşam FÇM çalışıcak");
          HandleGetFcmCalculator();
          setUyari(true);
          setLoading(false);
          return;
        }
        if (data == 1) {
          setUyariTip('error');
          setresponseMessage("Hata Oluştu !!!");
          HandleGetFcmCalculator();
          setUyari(true);
          setLoading(false);
          return;
        }
        if (data == 99) {
          setUyariTip('error');
          setresponseMessage("Hata Oluştu !!!");
          HandleGetFcmCalculator();
          setUyari(true);
          setLoading(false);
          return;
        }
        setLoading(false);
        return;
      }).catch((error) => {
        setLoading(false);
        return;
      });
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card className={classes.root}>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardContent>
          <Grid container justifyContent="center" style={{ marginTop: '16px' }}>
            <Grid item xs={12} sm={6} md={6}>
              <Divider style={{ margin: '1rem' }} />
              <Typography
                align='center'
                style={{ marginBottom: '1rem', color: '#0033a0', fontWeight: 'bold', fontSize: '1.2rem' }}
              >
                FÇM Hesapla
              </Typography>
              <Divider style={{ margin: '1rem' }} />
            </Grid>
          </Grid>

          <Grid container justifyContent="center" spacing={2} style={{ marginTop: '16px' }}>
            <Grid item xs={12} sm={6} md={6}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 400 }} size="large" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Son Hesaplanan Dönem</TableCell>
                      <TableCell align="right">Tarih</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fcmData.map((row) => (
                      <TableRow
                        key={row.name}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {row.aciklama}
                        </TableCell>
                        <TableCell align="right">{moment(row.tarih).format('DD/MM/YYYY HH:mm:ss') || '-'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid container justifyContent="center" item xs={12} style={{ marginTop: '16px' }}>
              <Grid item>
                <Button variant="contained" color="primary" fullWidth size='large' onClick={() => { fcmCalculator(); }}>
                  Hesapla
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );

}

export default SarisFcmCalculate;